import type { WebsiteSurfaceKey } from '@utazzo/shared';

/**
 * List URL pre-filtered to the rows the dashboard just counted as incomplete.
 * `f.<id>` is the DataGrid state convention, and `completeness` is the filter
 * id the three website list screens declare.
 *
 * `liveOnly` pins the status filter to PUBLISHED as well, because the chips
 * count live pages - without it a chip reading "102" would open a list of 116
 * (live + drafts) and quietly contradict itself.
 */
export const incompleteListPath = (surface: WebsiteSurfaceKey, liveOnly = true): string => {
  const params = new URLSearchParams({ 'f.completeness': 'INCOMPLETE' });
  if (liveOnly) params.set('f.status', 'PUBLISHED');
  return `${WEBSITE_SURFACE_META[surface].listPath}?${params.toString()}`;
};

/**
 * Display label + editor route per website surface. Shared by the
 * needs-attention card and the recently-edited feed so a row in either
 * one lands on the same edit screen.
 */
export const WEBSITE_SURFACE_META: Record<
  WebsiteSurfaceKey,
  { label: string; plural: string; listPath: string; editPath: (id: string) => string }
> = {
  blog: { label: 'Blog', plural: 'blogs', listPath: '/blogs', editPath: (id) => `/blogs/${id}` },
  blog_category: {
    label: 'Blog category',
    plural: 'blog categories',
    listPath: '/categories',
    editPath: () => '/categories',
  },
  page: { label: 'Page', plural: 'pages', listPath: '/pages', editPath: (id) => `/pages/${id}` },
  destination_page: {
    label: 'Destination',
    plural: 'destination pages',
    listPath: '/destination-pages',
    editPath: (id) => `/destination-pages/${id}`,
  },
  category_page: {
    label: 'Category page',
    plural: 'category pages',
    listPath: '/category-pages',
    editPath: (id) => `/category-pages/${id}`,
  },
  package: {
    label: 'Package',
    plural: 'packages',
    listPath: '/packages',
    editPath: (id) => `/packages/${id}`,
  },
};
